
    import { Component, Vue, Prop } from "vue-property-decorator";
     import VueCircle from 'vue2-circle-progress'

    @Component({
         components: {
            VueCircle}
    })
    export default class AlertPopUp extends Vue {

        @Prop()
        msgValue: any;
        @Prop()
        isSuccess: any;
        @Prop()
        scheduleToCommitment: any;
        @Prop()
        weekendCommitment: any;
        @Prop()
        scheduleBeyondcommitment: any;

        onCancelClick() { this.$emit('cancelled'); }
    }

